// extracted by mini-css-extract-plugin
export default {"header-row":"header-row_ekkl4ia7","shopping_cart":"shopping_cart_DEps7Gx9"};